// extracted by mini-css-extract-plugin
export default {"pictureContainer":"PpW7u5eQFX"};